// extracted by mini-css-extract-plugin
export var attribution = "_98-4";
export var authorName = "_98-5";
export var quote = "_98-3";
export var testimonial = "_98-2";
export var trustedBy = "_98-0";
export var trustedByLabel = "_98-1";